import { Image, Video } from '@cian/slider';
import { IconLock16 } from '@cian/ui-kit';
import { EMediaType, IMedia } from '../../../../types';
import { FC, PropsWithChildren } from 'react';
import styles from './Slides.css';

export const PhotoSlide: FC<IMedia> = ({ src, type }) => (
  <Image src={src} objectFit={type === EMediaType.Layout ? 'contain' : undefined} />
);

export const VideoSlide: FC<IMedia> = ({ src }) => <Video src={src} />;

export const BookedSlide: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['container']}>
    {children}
    <div className={styles['banner']}>
      <IconLock16 />
      <span className={styles['text']}>Квартира забронирована</span>
    </div>
  </div>
);
